import React from "react";
import { useAccessibility } from "../../../../../Store/contexts/AccessibilityContext";
import DefaultText from "../../../../../components/Accessibility/DefaultText";
import { useGestaoDeCronicosCaptacao } from "../../context/CaptacaoContext";
import "../../styles.css";
import LoadingApp from "../../../../../components/LoadingApp";

export const Detalhes = () => {
  const { textStyleAccessibility } = useAccessibility();
  const { loading, texts } = useGestaoDeCronicosCaptacao();

  return (
    <div>
      <LoadingApp showLoading={loading} />
      {!loading && (
        <div className="content-container">
          <h1
            className="gestao-de-cronicos-title"
            style={textStyleAccessibility}
          >
            Instruções
          </h1>
          {texts.map((t, i) => (
            <DefaultText key={i} text={t} />
          ))}
        </div>
      )}
    </div>
  );
};
